let pendingRefresh: Promise<string> | null = null;

export function refreshAccessToken(apiUrl: string): Promise<string> {
  if (!pendingRefresh) {
    pendingRefresh = (async () => {
      const refreshToken = localStorage.getItem('xmacna_auth_refresh_token');
      if (!refreshToken) throw new Error('No refresh token');

      const response = await fetch(`${apiUrl}/auth/refresh`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refresh_token: refreshToken }),
      });
      if (!response.ok) throw new Error('Refresh rejected');

      const data = await response.json();
      if (!data.success || !data.token || !data.refresh_token) {
        throw new Error('Invalid refresh response');
      }
      localStorage.setItem('xmacna_auth_token', data.token);
      localStorage.setItem('xmacna_auth_refresh_token', data.refresh_token);
      return data.token as string;
    })().finally(() => {
      pendingRefresh = null;
    });
  }
  return pendingRefresh;
}

export function clearAuthAndReload(): void {
  const authKey = 'strategy_auth_' + btoa('naocontapraninguem!');
  localStorage.removeItem(authKey);
  localStorage.removeItem('xmacna_auth_token');
  localStorage.removeItem('xmacna_auth_refresh_token');
  window.location.reload();
}
